import * as z from "zod/mini";
const absoluteUrlSchema = z.string().check(z.trim(), z.url());
export const runtimeEndpointsSchema = z.strictObject({
    apiUrl: z.optional(absoluteUrlSchema),
    coreUrl: z.optional(absoluteUrlSchema),
    realtimeUrl: z.optional(absoluteUrlSchema),
});
const parseAbsoluteUrl = (value) => {
    if (!value) {
        return null;
    }
    try {
        return new URL(value);
    }
    catch {
        return null;
    }
};
const normalizeOrigin = (value) => {
    const parsed = parseAbsoluteUrl(value);
    if (!parsed) {
        return null;
    }
    return parsed.origin;
};
export const resolveCoreUrl = (runtimeEndpoints) => {
    return parseAbsoluteUrl(runtimeEndpoints?.coreUrl);
};
export const resolveRealtimeUrl = (runtimeEndpoints) => {
    return parseAbsoluteUrl(runtimeEndpoints?.realtimeUrl);
};
export const resolveApiBaseUrl = (runtimeEndpoints) => {
    const apiUrl = runtimeEndpoints?.apiUrl;
    const parsed = parseAbsoluteUrl(apiUrl);
    if (!parsed) {
        return null;
    }
    if (!parsed.pathname || parsed.pathname === "/") {
        return null;
    }
    if (!parsed.pathname.endsWith("/")) {
        parsed.pathname = `${parsed.pathname}/`;
    }
    return parsed;
};
export const resolveTrpcBaseUrl = (runtimeEndpoints) => {
    const apiBaseUrl = resolveApiBaseUrl(runtimeEndpoints);
    if (!apiBaseUrl) {
        return null;
    }
    const normalizedApiPath = apiBaseUrl.pathname.endsWith("/")
        ? apiBaseUrl.pathname.slice(0, -1)
        : apiBaseUrl.pathname;
    if (!normalizedApiPath.endsWith("/v1")) {
        return null;
    }
    const trpcPath = normalizedApiPath.slice(0, -"/v1".length) || "/";
    return new URL(trpcPath, `${normalizeOrigin(apiBaseUrl.toString()) ?? ""}/`);
};
